<ng-container>
    <div class="link-list-box link-list-box__mobile">
        <div class="link-list-box__content">
            <a
                class="link-list-box__mobile-hamburger"
                (click)="toggleHamburger()"
                (keydown.enter)="toggleHamburger()"
                (keydown.space)="toggleHamburger()"
                tabindex="0"
                role="button"
                >Sections</a
            >
        </div>
    </div>

    <div [class]="mobileNavOpen ? ' link-list-box__mobile-open' : 'link-list-box__mobile-closed'" class="link-list-box">
        <div class="link-list-box__content">
            <ul class="link-list-box__list">
                @for (anchor of anchors; track anchor.id) {
                    <li class="link-list-box__item">
                        <a
                            (click)="goToAnchor(anchor)"
                            (keydown.enter)="goToAnchor(anchor)"
                            (keydown.space)="goToAnchor(anchor)"
                            [innerHtml]="anchor.name | translate"
                            tabindex="0"
                            role="link"
                            href="javascript:void(0)"></a>
                    </li>
                }
            </ul>
        </div>
    </div>
</ng-container>
